// 导入axios
import axios from "axios";
import {ElMessage} from 'element-plus'
// 进行一些全局配置 跨域
axios.defaults.withCredentials = true;
// 请求响应超时时间
axios.defaults.timeout = 5000;

// axios.defaults.headers["Content-Type"] = "application/json";
// request拦截器
axios.interceptors.request.use(
    (config: any) => {
        config.url =  "http://t.cms.hjcpay.com/"+ config.url.split(/\/api\//)[1];
        // console.log(config.url)
        if(config.url.indexOf('/api/parkDayFeeReport/searchCashJudge')===0){
            config.headers["Content-Type"] = "application/x-www-form-urlencoded";
        }else{
            config.headers["Content-Type"] = "application/json";
        }
        // config.headers["Content-Type"] = "application/json";
        // if (window.sessionStorage.getItem("token")) {
        //     // config.headers["Authorization"] = window.sessionStorage.getItem("token"); // 让每个请求携带自定义token 请根据实际情况自行修改
        // }
        return config;
    },
    (error) => {
        // 请求错误处理
        return Promise.reject(error);
    }
);
// response拦截器
axios.interceptors.response.use(
    (response: any) => {
        return response;
    },
    (error: any) => {
        const isTimeout = error.toString().includes("500");
        if (isTimeout) {
            ElMessage.error("请求已超时");
        }
        switch (error.response.data.status) {
            case 401:
                // ElMessage.error("token过期");
                break;
            case 500:
                ElMessage.error("服务器异常");
                break;
            case 400:
                ElMessage.error("错误的请求");
                break;
            case 404:
                ElMessage.error("未找到资源");
                break;
        }
        return Promise.reject(error);
    }
);

export function get(url: string, params: any) {
    return new Promise((resolve, reject) => {
        axios
            .get("/api/" + url, {
                params: params,
            })
            .then((response) => {
                resolve(response);
            })
            .catch((err) => {
                reject(err);
            });
    });
}
export function post(url: string, data: any,) {
    return new Promise((resolve, reject) => {
        axios
            .post(
                "/api/" + url, data,{}
            )
            .then(
                (response) => {
                    resolve(response);
                },
                (err) => {
                    reject(err);
                }
            );
    });
}

export function delete1(url: string, data: any) {
    return new Promise((resolve, reject) => {
        axios.delete("/api/" + url + data).then(
            (response) => {
                resolve(response);
            },
            (err) => {
                reject(err);
            }
        );
    });
}
